<template>
  <div style="width: 100%">
    <loading v-show="showLoading"></loading>

    <div class="home_content" style="padding-top: 1rem" v-if="!showLoading">
      <!--banner-->
      <div class="content_container banner_br" style="padding-bottom: 0" >
        <van-swipe class="banner_br" style="padding-bottom: 0"  :autoplay="3000" >
          <van-swipe-item v-for="(bannerItem, index) in bannerList" :key="index">
            <van-image id="banner1" @click="pushWebUrl(bannerItem.contentUrl)" class="banner_item" fit="cover" :src="bannerItem.imageUrl"/>
          </van-swipe-item>
        </van-swipe>
      </div>

      <van-tabs :sticky="true" :line-width="32" v-model="active" :isFixed="true" animated :swipeable="true" title-active-color="#EB84AB" style="border-style: none"  @change="changeAction">
        <van-tab title="直播课堂" >
          <!--正在直播-->
          <div style="padding:1rem;margin-bottom: 0.5rem">
            <div class="gl_content ovh" style="padding-bottom: 1rem;box-shadow: 0px 1px 10px #F0F0F0;border-radius: 0.2rem;">
              <p class="gl_title themeColor" style="padding-left: 0.5rem;margin-left: 1rem;line-height: 1rem">正在直播</p>
              <div class="content_container">
                  <div class="ovh" style="margin-bottom: 0.5rem" v-for="(video,index) in videoList" @click="goVideoDetail(0,video.videoId)">
                    <van-image class="fl gl_border" style="width: 8rem;height: 5.8rem;margin-right: 0.5rem" fit="cover" :src="video.videoImg" />
                    <div class="fl" style="width: 10.8rem">
                      <p class="clear_style zt14 blod black">{{video.videoTitle}}</p>
                      <p class="clear_style zt14 grey">{{video.videoDesc}}</p>
                      <p class="clear_style zt14 black" style="margin-top: 1rem;">{{video.videoAuthorName}}</p>
                    </div>
                  </div>
                <!--<router-link to="classItemInfo">-->
                  <!--<div class="ovh" style="margin-bottom: 0.5rem">-->
                    <!--<van-image class="fl gl_border" style="width: 8rem;height: 5.8rem;margin-right: 0.5rem" fit="cover" src="produtItem.imageUrl" />-->
                    <!--<div class="fl" style="width: 10.8rem">-->
                      <!--<p class="clear_style zt14 blod black">hellokittypark萌娃课堂</p>-->
                      <!--<p class="clear_style zt14 grey">幼儿学习，1V1互动课堂，在线轻松学...</p>-->
                      <!--<p class="clear_style zt14 black" style="margin-top: 1rem;">小明老师</p>-->
                    <!--</div>-->
                  <!--</div>-->
                <!--</router-link>-->
              </div>
            </div>
          </div>
          <!--精彩回放-->
          <div style="padding: 0 1rem;margin-bottom: 2rem">
            <div class="gl_content ovh" style="padding-bottom: 1rem;box-shadow: 0px 1px 10px #F0F0F0;border-radius: 0.2rem;">
              <p class="gl_title themeColor" style="padding-left: 0.5rem;margin-left: 1rem;line-height: 1rem">精彩回放</p>
              <div class="content_container">
                <div class="gl_info fl" style="border-style: none;width: 9.3rem;height: 11.5rem" v-for="(back,index) in videoBackList" @click="goVideoDetail(2,back.videoId)">
                  <van-image class="full_w gl_border" style="width: 9.3rem;height: 6.56rem" fit="cover" :src="back.videoImg" />
                  <p class="gl_info_title zt14" style="height: auto">{{back.videoDate|formatDate}}</p>
                  <span class="fl gl_info_price zt14" style="color: black;margin-top: 0.3rem">{{back.videoTitle}}</span>
                </div>
              </div>
            </div>
            <refresh style="position:relative;-webkit-overflow-scrolling : touch;overflow:auto;margin-bottom:45px;" @zj-load="loadMore" :lastPage='{total: !allLoaded, empty: videoBackList.length,show:show}'></refresh>
          </div>
        </van-tab>
        <van-tab title="精彩视频">
          <!--正在直播-->
          <div style="padding:1rem;margin-bottom: 0.5rem">
            <div class="gl_content ovh" style="padding-bottom: 1rem;box-shadow: 0px 1px 10px #F0F0F0;border-radius: 0.2rem;">
              <div class="content_container" style="padding: 1rem">
                <div class="ovh" style="margin-bottom: 1rem" v-for="(video,index) in videoList" @click="goVideoDetail(1,video.videoId)">
                  <van-image class="fl gl_border" style="width: 8rem;height: 5.8rem;margin-right: 0.5rem;border-radius: 0.5rem;" fit="cover" :src="video.videoImg" />
                  <div class="fl" style="width: 10.8rem">
                    <p class="clear_style zt14 blod black" style="height: 4.5rem">{{video.videoTitle}}</p>
                    <p class="clear_style zt14 grey">发布时间：{{video.videoDate|formatDate}}</p>
                  </div>
                </div>

              </div>
            </div>
          </div>
          <refresh style="position:relative;-webkit-overflow-scrolling : touch;overflow:auto;margin-bottom:45px;" @zj-load="loadMore" :lastPage='{total: !allLoaded, empty: videoList.length,show:show}'></refresh>

        </van-tab>
      </van-tabs>

      <!--<div class="cart_content" v-if="emptyList">-->
        <!--<p class="tc grey zt16" style="padding: 2rem 0">没有视频～</p>-->
      <!--</div>-->
    </div>
  </div>
</template>

<script>

  import Vue from 'vue';
  import { storeName,prodCatalogId,loginInfo,productRecommend,shareUrl } from '@/router/Constant'
  import { getClassBanner ,getVideoList} from '@/router/api';
  import { setStore,getStore,getCookie,setCookie } from '@/utils/mUtil';
  import { NavBar,Swipe,SwipeItem,Image,Grid,Tabbar,Tab, Tabs,Toast,Search,PullRefresh,Dialog } from 'vant';
  import footerView from '../common/footer';
  import loading from '@/components/page/common/loading.vue'
  import refresh from '@/components/page/common/refresh.vue';

  export default {
    name: 'classList',
    data () {
      return {
        showLoading:false,
        bannerList:[],
        productStoreId:storeName,
        prodCatalogId:prodCatalogId,
        active:0,//0直播1视频
        type:0,//0直播1视频2精彩回放
        viewSize:10,
        viewIndex:0,
        videoList:[],
        externalLoginKey:getStore('externalLoginKey'),
        videoBackList:[],
        show: true,
        allLoaded: false,
        emptyList:false,
      }
    },
    methods: {

      async initData() {
        if(getStore('videoStatus')!=''&&getStore('videoStatus')!=null&&getStore('videoStatus')!=undefined){
          this.active = parseInt(getStore('videoStatus'))
          this.type = parseInt(getStore('videoStatus'))
        }else{
          this.type = 0
          this.active = 0
        }this.viewIndex = 0
        this.videoList = []
        this.videoBackList = []
        this.getClassBanner();
        this.getVideoList()
        this.getBackWatch()
      },

      // 获取banner
      getClassBanner (){
        getClassBanner({bannerName:'Hello Kitty课堂首页banner'})
          .then(res => {
            console.log("getClassBanner")
            console.log(res)
            this.bannerList = res.resultMap.listAdv
          })
          .catch(err => {
            console.log(err);
          });
      },

      //获取直播/视频
      getVideoList(){
        var param = {
          type:this.type,
          viewIndex:this.viewIndex,
          viewSize:this.viewSize
        }
        getVideoList(param)
          .then(res => {
            console.log("getVideoList")
            console.log(res)

            if(res._ERROR_MESSAGE_){
              Toast(res._ERROR_MESSAGE_)
            }else{
              if (res.videoList.length == 0) {
                this.emptyList = true;
              } else {
                this.emptyList = false;
              }
              if (res.videoList.length < this.viewSize) {
                this.allLoaded = true
              } else {
                this.allLoaded = false
              }

              this.videoList = res.videoList

            }


            setTimeout(() => {
              this.showLoading = false;
              this.isLoading = false;
            }, 1000);

          })
          .catch(err => {
            console.log(err);
          });
      },


      // 获取精彩回放
      getBackWatch(){
        var param = {
          type:2,
          viewIndex:this.viewIndex,
          viewSize:this.viewSize
        }
        getVideoList(param)
          .then(res => {
            console.log("getBackWatch")
            console.log(res)

            if(res._ERROR_MESSAGE_){
              Toast(res._ERROR_MESSAGE_)
            }else{
              if (res.videoList.length == 0) {
                this.emptyList = true;
              } else {
                this.emptyList = false;
              }
              if (res.videoList.length < this.viewSize) {
                this.allLoaded = true
              } else {
                this.allLoaded = false
              }

              this.videoBackList = res.videoList

            }


            setTimeout(() => {
              this.showLoading = false;
              this.isLoading = false;
            }, 1000);

          })
          .catch(err => {
            console.log(err);
          });
      },

      changeAction(){
        if(this.active == 0){
          this.type = 0
          this.viewIndex = 0
          this.videoList = []
          this.getVideoList()
          // this.getBackWatch()
        }else{
          this.active = 1
          this.type = 1
          this.viewIndex = 0
          this.videoList = []
          this.getVideoList()

        }
      },


      //上拉加载
      loadMore() {
        if (!this.allLoaded) {
          if(this.type == 1){
            this.viewIndex ++;
            var param = {
              token:this.token,
              type:this.type,
              viewIndex:this.viewIndex,
              viewSize:this.viewSize
            }

            getVideoList(param)
              .then(res => {
                console.log(res)

                if (res.videoList.length < this.viewSize) {
                  this.allLoaded = true
                } else {
                  this.allLoaded = false
                }

                var oldSaleList = this.videoList
                var newSaleList = oldSaleList.concat(res.videoList)
                console.log(newSaleList)
                this.videoList = newSaleList
                this.viewIndex = res.viewIndex;

                setTimeout(() => {
                  this.showLoading = false;
                  this.isLoading = false;
                }, 1000);
              })
              .catch(err => {
                console.log(err);
              });
          }else{
            this.viewIndex ++;
            var param = {
              token:this.token,
              type:2,
              viewIndex:this.viewIndex,
              viewSize:this.viewSize
            }
            getVideoList(param)
              .then(res => {
                console.log(res)

                if (res.taskList.length < this.viewSize) {
                  this.allLoaded = true
                } else {
                  this.allLoaded = false
                }

                var oldSaleList = this.videoBackList
                var newSaleList = oldSaleList.concat(res.videoList)
                this.videoBackList = newSaleList
                this.viewIndex = res.viewIndex;

                setTimeout(() => {
                  this.showLoading = false;
                  this.isLoading = false;
                }, 1000);
              })
              .catch(err => {
                console.log(err);
              });
          }

        }
      },

      goVideoDetail(typeId,videoId){
        setStore('videoStatus',this.active)
        this.$router.push({name:'classItemInfo',query:{typeId:typeId,videoId:videoId}})
      }

    },

    filters: {
      formatDate: function (value) {
        if(value!=null&&value!=''&&value!=undefined ){
          let date = new Date(value)
          // let y = date.getFullYear()
          let MM = date.getMonth() + 1
          MM = MM < 10 ? ('0' + MM) : MM
          let d = date.getDate()
          d = d < 10 ? ('0' + d) : d
          return MM + '/' + d
        }else{
          return ''
        }
      }
    },
    components: {
      [NavBar.name]: NavBar,
      [Swipe.name]: Swipe,
      [SwipeItem.name]: SwipeItem,
      [Image.name]: Image,
      [Grid.name]: Grid,
      [Tabbar.name]: Tabbar,
      [Tab.name]: Tab,
      [Tabs.name]: Tabs,
      [Toast.name]: Toast,
      [Search.name]: Search,
      [PullRefresh.name]: PullRefresh,
      [Dialog.name]: Dialog,
      footerView,
      loading,
      refresh
    },
    mounted() {
      this.initData();
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

  .home_content {
    padding-top: 3rem;
  }

  .home_search {
    width: 100%;height: 100%;position: fixed;top: 0;background-color: white;z-index: 99;
  }

  .head_top {
    background-color: white;padding-top: 0.5rem;padding-bottom: 0.5rem;position: fixed;top: 0;left: 0;width: 100%;z-index: 99
  }

  .head_top_search {
    width: 20rem;margin-left: 0.85rem;background-color: #f5f5f5;height: 2rem;line-height: 2rem;padding: 0 0.8rem;border-radius: 1rem
  }

  .head_top_search_icon {
    width: 0.8rem;height: 0.8rem;margin-right: 0.5rem
  }

  .head_top_search_placeholder {
    font-size: 0.75rem;color: #999999
  }

  .content_container {
    padding: 0 1rem
  }

  .banner_item {
    width: 21.5rem;
    height: 10rem;
    border-radius: 0.5rem;
  }

  .banner_br {
    padding-bottom: 1rem;
  }

  .base_line {
    height: 0.6rem;
    background-color: #f4f4f4;
  }

  .adv_height {
    height: 5rem;
  }

  .classify_item {
    float: left;
    width: 3.3rem;
    height: 4rem;
    padding: 0.5rem 1rem;
  }

  .classify_adv_content {
    padding-top: 1rem;
    padding-bottom: 1rem;
  }

  .classify_adv_content > div:nth-child(1) {
    width:8.75rem;
    height: 11.25rem;
    margin-right: 0.6rem;
  }

  .classify_adv_content > div:nth-child(1) > a  > div {
    width:8.75rem;
    height: 11.25rem;
  }

  .classify_adv_content > a > div:nth-child(2) {
    width:12rem;
    height: 11.25rem;
  }

  .classify_adv_content > div:nth-child(2) > a  > div:nth-child(1) {
    width: 12rem;height: 5.3rem;margin-bottom: 0.6rem
  }

  .classify_adv_content a > div:nth-child(2) > a > div:nth-child(2) {
    width: 12rem;height: 5.3rem;margin-bottom: 0;
  }

  .gl_content {
    padding-bottom: 3rem;
  }

  .gl_border {
    border-radius: 0.4rem 0.4rem 0 0;
    width: 10.25rem;height: 10.25rem;
  }

  .gl_title {
    padding-left: 1rem;font-weight: bold;border-left-width: 0.1rem;border-left-style: solid;border-left-color: #EB84AB
  }

  .gl_info {
    width: 10.25rem;height: 14.5rem;border-width: 1px;border-color: #F4F4F4;border-style: solid;padding-bottom: 0.5rem;border-radius: 0.5rem;overflow: hidden;
  }

  .gl_info:nth-child(odd) {
    margin-right: 0.5rem;
  }

  .gl_info_title {
    padding: 0 0.1rem;margin:0 0.5rem 0;font-size: 0.875rem;color: #666666;height: 2.1rem;
  }

  .gl_info_price {
    margin-left: 0.5rem;font-size: 0.875rem;color: #EB84AB;margin-top: 0.5rem;
  }

  .gl_info_addCart {
    margin-right: 0.5rem;font-size: 0.875rem;color: #EB84AB;margin-top: 0.5rem;
  }

  .tag_list > li {
    line-height: 2rem;
    margin: 0 0.6rem 0.6rem 0;
  }

  .tag_item {
    background-color: #f5f5f5;padding: 0.5rem 1rem;border-radius: 0.3rem;
  }

  .router-slid-enter-active, .router-slid-leave-active {
    transition: all .4s;
  }
  .router-slid-enter, .router-slid-leave-active {
    transform: translate3d(2rem, 0, 0);
    opacity: 0;
  }

</style>




// WEBPACK FOOTER //
// src/components/page/mengwa/classList.vue